import { createContext } from 'react';

export const NotificationsContext = createContext({
  isLoading: false,
  notifications: [],
  unreadCount: 0,
  lastUpdate: Date.now(),
  addNotification: () => console.warn('addNotification not implemented'),
  setNotificationsOnRead: () =>
    console.warn('setNotificationsOnRead not implemented'),
});
